import React, { useRef } from 'react';
import {ConnectButton} from '@rainbow-me/rainbowkit';
import NereusButton from '../NereusButton/NereusButton';
// @ts-ignore
import jazzicon from '@metamask/jazzicon';

import './NereusConnectButton.scss';
import {useSwitchChainToPolygon} from "../../hooks/useSwitchChainToPolygon";
import {polygonChain} from "../../instances/blockchain-instances";

export interface NereusConnectButtonProps {
    children?: React.ReactNode;
    bridgeButton?: React.ReactNode;
    isDepositBlock?: boolean;
}

/* Function from metamask repository itself */
function jsNumberForAddress(address: string): number {
    const addr = address.slice(2, 10);
    const seed = parseInt(addr, 16);
    return seed;
}

const NereusConnectButton = ({ children, bridgeButton }: NereusConnectButtonProps) => {

    const switchChainToPolygon = useSwitchChainToPolygon();

    const jazzIconRef = useRef<HTMLDivElement | null>(null);

    return (
        <ConnectButton.Custom>
            {({
                  account,
                  chain,
                  openAccountModal,
                  openChainModal,
                  openConnectModal,
                  authenticationStatus,
                  mounted,
              }) => {
                const ready = mounted && authenticationStatus !== 'loading';
                const connected =
                    ready &&
                    account &&
                    chain &&
                    (!authenticationStatus ||
                        authenticationStatus === 'authenticated');

                const jazzIcon = jazzicon(24, account ? jsNumberForAddress(account.address) : 0);

                if (jazzIconRef.current) {
                    jazzIconRef.current.innerHTML = '';
                    jazzIconRef.current.appendChild(jazzIcon)
                }

                return (
                    <div
                        {...(!ready && {
                            'aria-hidden': true,
                            'style': {
                                opacity: 0,
                                pointerEvents: 'none',
                                userSelect: 'none',
                            },
                        })}
                    >
                        {(() => {
                            if (!connected) {
                                return (
                                <NereusButton
                                    className={`flex-1 long-btn active NereusConnectButton__connectBtn`}
                                    variant="contained"
                                    onClick={openConnectModal}
                                >
                                    Connect&nbsp;Wallet
                                </NereusButton>);
                            }

                            if (chain.unsupported || chain.id !== polygonChain.id) {
                                const wrongNetworkButton = (
                                    <NereusButton
                                        onClick={switchChainToPolygon}
                                        className={`flex-1 long-btn active NereusConnectButton__wrongNetwork`}
                                        variant="outlined"
                                        color="secondary"
                                    >
                                        Wrong&nbsp;network
                                    </NereusButton>
                                )
                                return (
                                    bridgeButton
                                        ? (
                                            <div className="flex gap-4">
                                                {bridgeButton}
                                                {wrongNetworkButton}
                                            </div>
                                        )
                                        : wrongNetworkButton
                                );
                            }

                            if (children) {
                                return children;
                            }

                            return (
                                <div style={{display: 'flex', gap: 20}}>
                                    <div style={{display: 'flex', alignItems: 'center', color: "white"}}>
                                        <div
                                            className="NereusConnectButton__chainIcon"
                                            style={{
                                                width: 24,
                                                height: 24,
                                                borderRadius: 999,
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {chain.iconUrl && (
                                                <img
                                                    alt="Polygon"
                                                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iQSIgeDE9Ii0xOC4yNzUlIiB4Mj0iODQuOTU5JSIgeTE9IjguMjE5JSIgeTI9IjcxLjM5MyUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNhMjI5YzUiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiM3YjNmZTQiLz48L2xpbmVhckdyYWRpZW50PjxjaXJjbGUgaWQ9IkIiIGN4PSIxNCIgY3k9IjE0IiByPSIxNCIvPjwvZGVmcz48ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxtYXNrIGlkPSJDIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNCIi8+PC9tYXNrPjxnIGZpbGwtcnVsZT0ibm9uemVybyI+PHBhdGggZmlsbD0idXJsKCNBKSIgZD0iTS0xLjMyNi0xLjMyNmgzMC42NTF2MzAuNjUxSC0xLjMyNnoiIG1hc2s9InVybCgjQykiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTguMDQ5IDE3LjAyMWwzLjk2LTIuMjg3YS42ODEuNjgxIDAgMCAwIC4zNC0uNTg5VjkuNTcyYS42ODMuNjgzIDAgMCAwLS4zNC0uNTlsLTMuOTYtMi4yODZhLjY4Mi42ODIgMCAwIDAtLjY4IDBsLTMuOTYgMi4yODdhLjY4Mi42ODIgMCAwIDAtLjM0LjU4OXY4LjE3M0wxMC4yOSAxOS4zNWwtMi43NzctMS42MDR2LTMuMjA3bDIuNzc3LTEuNjA0IDEuODMyIDEuMDU4VjExLjg0bC0xLjQ5Mi0uODYxYS42ODEuNjgxIDAgMCAwLS42OCAwbC0zLjk2IDIuMjg3YS42ODEuNjgxIDAgMCAwLS4zNC41ODl2NC41NzNjMCAuMjQyLjEzLjQ2OC4zNC41OWwzLjk2IDIuMjg2YS42OC42OCAwIDAgMCAuNjggMGwzLjk2LTIuMjg2YS42ODIuNjgyIDAgMCAwIC4zNC0uNTg5di04LjE3NGwuMDUtLjAyOCAyLjcyOC0xLjU3NSAyLjc3NyAxLjYwM3YzLjIwOGwtMi43NzcgMS42MDMtMS44My0xLjA1NnYyLjE1MWwxLjQ5Ljg2YS42OC42OCAwIDAgMCAuNjggMHoiLz48L2c+PC9nPjwvc3ZnPg=="
                                                    style={{ width: 24, height: 24 }}
                                                />
                                            )}
                                        </div>
                                        <span className="NereusConnectButton__chainName">Polygon</span>
                                    </div>

                                    <NereusButton
                                        onClick={openAccountModal}
                                        className={`flex-1 long-btn active flex items-center NereusConnectButton__addressBtn`}
                                        color="secondary"
                                    >
                                        <div className="NereusConnectButton__jazzIcon" ref={jazzIconRef} />
                                        {account.displayName}
                                    </NereusButton>
                                </div>
                            );
                        })()}
                    </div>
                );
            }}
        </ConnectButton.Custom>
    )
};

export default NereusConnectButton;
